import styled from 'styled-components';
import { media } from 'style-utils';

import { NitroIcon } from 'nitro-components';

export const TabContainer = styled.span`
  color: ${props => props.theme.color.primary};
  text-transform: uppercase;
  cursor: pointer;
`;

export const NavContainer = styled.div`
  background-color: ${props => props.theme.color.white};
  border: solid 1px ${props => props.theme.color.iceBlue};
  text-transform: uppercase;
  width: 100vw;
  position: fixed;
  ${media.desktop`
    z-index: 1;
     padding: 16px;
  `}
  ${media.mobileTablet`
    padding: 14px 16px;
    height: 44px;
    position: static;
    & span {
      font-family: ${props => props.theme.font.default};
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      color: #4d4f54;
    }

  `}
`;
export const SearchResultContainer = styled.div`
  color: ${props => props.theme.color.base2};
  ${media.mobileTablet`
    width: 100vw;
    height: 80%;
    overflow: scroll;
  `}
`;

export const EntryCountContainer = styled.div`
  background-color: ${props => props.theme.color.white};
  border: solid 1px ${props => props.theme.color.iceBlue};
  padding: 0;
  width: 100vw;
  position: static;
  top: 96px;
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 25px 0;
`;
export const LoginTimeDiv = styled.div`
  margin: 25px 0 0 0;
`;
export const PersonalDetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  height: 44px;
  margin: 24px 0 0 0;
  padding: 12px 16px;
`;

export const Container = styled.div`
  top: 56px;
  position: relative;
  padding: 0 28px;
  max-width: 100%;
  min-width: 1120px;
  margin: 16px auto;
  width: ${props => props.wide && '80%'};

  ${media.mobileTablet`
    position: static;
    margin: 0;
    padding: 0;
    & > div {
      padding 0;
      width: 100vw;
      overflow: scroll;
    }
  `}
`;
export const TabsContainer = styled.div`
  background-color: ${props => props.theme.color.primary};
  opacity: 0.1;
`;
export const NumPerPageOptionContainer = styled.div`
  align-self: flex-start;
  position: relative;
  left: 0;
  margin: 0;
  & p {
    padding: 10px 24px;
    margin: 0;
  }
  & p:first-of-type {
    padding: 10px 24px 10px 0;
    border-right: 1px solid ${props => props.theme.color.veryLightBlue};
    color: ${props => props.theme.color.grey8};
    font-size: 16px;
  }
  ${media.mobileTablet`
    margin: 0 16px 16px 16px;
  `}
  padding: 0px;
  display: flex;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 25px;
  min-width: 286px;
  // width: 700px;
  align-item: center;
  align-centent: center;

  & span,
  p {
    font-family: ${props => props.theme.font.bold};
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: ${props => props.theme.color.grey8};
    padding: 12px 0px;
    margin: 0 8px;
  }
  & input {
    margin: 0 auto;
    padding: 4px 15px 0 15px;
    height: 35px;
    width: 300px;
    border: none;
    border: 1px solid ${props => props.theme.color.border};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: ${props => props.theme.color.base2};
    background-image: none;
    &:focus {
      outline: none;
    }
  }
  & input ~ span {
    padding: 8px;
    width: 16px;
  }
  & input + ul {
    position: absolute;
    margin: 0;
    padding: 0;
    list-style-type: none;
    top: 36px;
    right: 20px;
    width: 308px;
    border: solid 1px #d6dee4;
    background-color: ${props => props.theme.color.white};
    & p {
      margin: 11px 0 0 16px;
      width: 173px;
      height: 20px;
      font-family: ${props => props.theme.font.default};
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.82;
      letter-spacing: 0.4px;
      color: #3f3f3f;
    }
    & p ~ li {
      text-align: -webkit-match-parent;
      width: 324px;
      height: 40px;
      padding: 12px;
      font-family: ${props => props.theme.font.default};
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      color: #4d4f54;
      &:hover {
        background-color: #f2f6f7;
        width: 100%;
        font-family: ${props => props.theme.font.bold};
      }
    }
    & svg {
      fill: ${props => props.theme.color.base2};
      margin-right: 9px;
    }
  }
`;

export const SearchTypeSelector = styled.div`
  position: relative;
  width: 165px;
  height: 32px;
  margin: 0 8px;

  & button {
    height: 35px;
    border: none;
    background-color: #f8f9f9;
    & div {
      color: #4d4f54;
    }
    & svg {
      fill: #4d4f54;
    }
    & + ul {
      font-family: ${props => props.theme.font.default};
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #d6dee4;
      background-color: #ffffff;
      width: 165px;
      & li {
        width: 100%;
        height: 40px;
        line-height: 16px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        color: #4d4f54;
        letter-spacing: normal;
        padding: 12px;
        &:hover {
          width: 100%;
          height: 40px;
          font-family: ${props => props.theme.font.bold};
          background-color: #f2f6f7;
        }
      }
    }
  }
`;
export const SearchResultStyleHeader = styled.div`
  font-family: ${props => props.theme.font.bold};
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: normal;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${props => props.theme.color.greyishBrown};
  padding: 0 0 16px 0;
  ${media.mobileTablet`
    padding: 16px 16px 12px 16px;
  `}

  & > span {
    font-family: ${props => props.theme.font.default};
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.11;
    letter-spacing: normal;
  }
`;
export const Main = styled.div`
  position: relative;
  width: 100%;
  ${media.mobileTablet`
    width: 100vw;
  `}
`;

export const GlobalSearchSection = styled.div`
  align-self: flex-start;
  position: relative;
  left: 0;
  padding: 0px 18px;
  display: flex;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 25px;
  min-width: 460px;
  width: 550px;
  background-color: #f8f9f9;

  & input {
    margin: 0 auto;
    padding: 4px 15px 0 15px;
    height: 35px;
    width: 300px;
    border: none;
    border: 1px solid ${props => props.theme.color.border};
    font-family: ${props => props.theme.font.default};
    font-size: 14px;
    font-weight: normal;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: ${props => props.theme.color.gunmetal};
    background-color: #f8f9f9;
    background-image: none;
    &:focus {
      outline: none;
    }
  }
  & input::placeholder {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: #aeb3c0;
  }
  & input ~ span {
    padding: 8px;
    width: 16px;
  }
  & input + ul {
    position: absolute;
    margin: 0;
    padding: 0;
    list-style-type: none;
    top: 36px;
    right: 20px;
    width: 308px;
    border: solid 1px #d6dee4;
    background-color: ${props => props.theme.color.white};
    & p {
      margin: 11px 0 0 16px;
      width: 173px;
      height: 20px;
      font-family: ${props => props.theme.font.default};
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.82;
      letter-spacing: 0.4px;
      color: #3f3f3f;
    }
    & p ~ li {
      text-align: -webkit-match-parent;
      width: 324px;
      height: 40px;
      padding: 12px;
      font-family: ${props => props.theme.font.default};
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      color: #4d4f54;
      &:hover {
        background-color: #f2f6f7;
        width: 100%;
        font-family: ${props => props.theme.font.bold};
      }
    }
    & svg {
      fill: ${props => props.theme.color.base2};
      margin-right: 9px;
    }
  }
`;

export const GlobalSearchDeskTopDropDown = styled.div`
  position: relative;
  width: 208px;
  height: 38px;
  & button {
    height: 35px;
    border: none;
    background-color: #f8f9f9;
    & div {
      color: #4d4f54;
    }
    & svg {
      fill: #4d4f54;
    }
    & + ul {
      font-family: ${props => props.theme.font.default};
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #d6dee4;
      background-color: #ffffff;
      width: 200px;
      & li {
        width: 100%;
        height: 40px;
        line-height: 16px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        color: #4d4f54;
        letter-spacing: normal;
        padding: 12px;
        &:hover {
          width: 100%;
          height: 40px;
          font-family: ${props => props.theme.font.bold};
          background-color: #f2f6f7;
        }
      }
    }
  }
`;

export const Background = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  opacity: ${props => (props.open ? 1 : 0)};
  left: ${props => (props.open ? '0' : '-100%')};
  transition: left 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    opacity 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: ${props => props.theme.color.white};
  z-index: 1400;
  pointer-events: auto;
`;

export const Dialog = styled.section`
  position: fixed;
  box-sizing: border-box;
  z-index: 1400;
  top: 0px;
  left: ${props => (props.open ? '0' : '-100%')};
  width: 100%;
  height: 100%;
  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;

export const DialogContainer = styled.div`
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;

  height: 100%;
  margin: 0px auto;
  z-index: 1500;
  opacity: ${props => (props.open ? 1 : 0)};
  max-height: 100%;
  overflow-y: auto;
  padding: 0;
  color: ${props => props.theme.color.base2};
    
  box-sizing: border-box;
  font-family: ${props => props.theme.font.default};
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px,
    rgba(0, 0, 0, 0.22) 0px 10px 18px;
  border-radius: 2px;
  transition: all 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  & span {
    font-family: ${props => props.theme.font.bold};
    align-items: center;
    font-size: 13px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    padding: 15px 20px;
  }

  & input + ul {
    position: absolute;
    margin: 0 20px;
    padding: 0;
    list-style-type: none;
    top: 36px;
    right: 20px;
    width: 308px;
    border: solid 1px #d6dee4;
    background-color: ${props => props.theme.color.white};
`;
export const MobileHeader = styled.div`
  display: flex;
  justify-content: space-between;
  height: 52px;
`;

export const HeaderIcon = styled(NitroIcon)`
  ${media.mobileTablet`
    padding: 16px 20px;
    background: ${props => props.theme.color.primary};
  `}
`;

export const GlobalSearchMobileDropDown = styled.div`
  margin: 8px 20px;
  padding: 0;
  height: 40px;
  & button {
    border: 1px solid #d6dee4;
    border-radius: 22px;
    background-color: #f8f9f9;
    & div {
      color: #4d4f54;
    }
    & svg {
      fill: #4d4f54;
    }
    & + ul {
      font-family: ${props => props.theme.font.default};
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #d6dee4;
      background-color: #ffffff;
      width: 95%;
      margin: 0 auto;
      & li {
        width: 100%;
        height: 40px;
        line-height: 16px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: normal;
        color: #4d4f54;
        padding: 12px;
        &:hover {
          width: 100%;
          height: 40px;
          font-family: ${props => props.theme.font.bold};
          background-color: #f2f6f7;
        }
      }
    }
  }
`;
export const GlobalSearchMobileInput = styled.div`
  position: relative;
  margin: 8px 20px;
  padding: 0;
  display: flex;
  justify-content: space-between;
  border: 1px solid #d6dee4;
  border-radius: 22px;
  align-items: center;
  height: 40px;
  background-color: #f8f9f9;

  & input {
    margin: 0 16px;
    flex-grow: 1;
    padding: 8px 0;
    height: 38px;
    width: 100%;
    border: none;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: ${props => props.theme.color.greyishBrown};
    background-color: #f8f9f9;
    background-image: none;
    &:focus {
      outline: none;
    }
  }
  & input::placeholder {
    color: ${props => props.theme.color.brownGrey};
  }
  & input + ul {
    position: absolute;
    margin: 0 auto;
    padding: 0;
    list-style-type: none;
    top: 34px;
    width: calc(100% - 40px);
    border: solid 1px #d6dee4;
    background-color: ${props => props.theme.color.white};
    & p {
      margin: 9px 0 8px 12px;
      width: 173px;
      height: 20px;
      font-family: ${props => props.theme.font.bold};
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.82;
      letter-spacing: 0.4px;
      color: #3f3f3f;
    }
    & p ~ li {
      text-align: -webkit-match-parent;
      width: 324px;
      height: 40px;
      padding: 12px;
      font-family: ${props => props.theme.font.default};
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      color: #4d4f54;
      width: 100%;
      &:hover {
        background-color: #f2f6f7;
        width: 100%;
        font-family: ${props => props.theme.font.bold};
      }
      span {
        padding: 0;
      }
    }
    & svg {
      fill: #4d4f54;
      margin-right: 4px;
    }
  }
`;

export const DetailContainer = styled.div`
  margin: 12px 16px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
export const DetailEntry = styled.dl`
  margin: 16px;
  width: ${props => (props.permission ? '100%' : '50%')};
  padding: 0;
  margin: ${props => (props.permission ? '8px 0' : '0')};
  & > div {
    width: ${props => (props.permission ? '75%' : '90%')};
  }
`;

export const DetailTitle = styled.dt`
  float: left;
  width: 20%;
  height: 22px;
  margin: ${props => (props.edit ? '0' : '4px 0')};
  padding: ${props => (props.edit ? '18px 0' : '4px 0')};
  font-size: 14px;
  font-family: ${props => props.theme.font.bold};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
`;
export const DetailContent = styled.dd`
  float: left;
  width: ${props => (props.edit ? (props.permission ? '75%' : '60%') : '80%')};
  height: 22px;
  margin: ${props => (props.edit ? '4px' : '4px 0')};
  padding: ${props => (props.edit ? '0' : '4px 0')};
  font-size: 14px;
  font-family: ${props => props.theme.font.default};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  & > div {
    border: 1px solid ${props => props.theme.color.border};
    border-radius: 4px;
    // height: 47px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    & > span {
      padding: 4px;
      margin: 4px 8px;
      border: 1px solid ${props => props.theme.color.primary};
      border-radius: 4px;
      background-color: ${props => `${props.theme.color.primary}40`}};
    }
    & ul {
      position: relative;
      width: 100%;
    }
  }
`;

export const ResultHeader = styled.div`
  background: #53942533;
  color: #539425;
  margin: 0 0 14px 0;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.23px;
  font-size: 14px;
  font-family: ${props => props.theme.font.default};
  padding: 12px;
  display: flex;
  justify-content: space-between;
`;



// WEBPACK FOOTER //
// ./src/features/userManagement/ResultStyle.js